import Api from "./api";

export const DIAGNOSIS_API = {
  method: "POST",
  url: "/surgery/diagnosis",
};

export const diagnosis = async ({
  doctorId,
  surgeryId,
  survey,
  diagnosisId,
  dicomImg,
  img,
  position,
}) => {
  try {
    if (!img) {
      throw new Error("img는 필수입니다.");
    }
    const formData = new FormData();
    const surgeryRegister = {
      doctorId,
      ...(surgeryId && { surgeryId }),
      ...(diagnosisId && { diagnosisId }),
      survey,
      position,
    };

    formData.append("surgeryRegister", JSON.stringify(surgeryRegister));
    formData.append("img", img);

    if (dicomImg) {
      formData.append("dicomImg", dicomImg);
    }

    const response = await Api.post(DIAGNOSIS_API.url, formData);
    return response.data;
  } catch (error) {
    return error;
  }
};
